
    <div class="extra-notes-redirect">
      <ng-container *ngIf="!failed">
        <mat-spinner diameter="48"></mat-spinner>
        <p>Opening Extra Notes&hellip;</p>
      </ng-container>

      <ng-container *ngIf="failed">
        <h3>Couldn't confirm your login</h3>
        <p>
          We couldn't load your user profile, so Extra Notes can't record who is
          posting. Reload this page, or open the location from the Locations grid
          and use the notes button there.
        </p>
      </ng-container>
    </div>
  